import React from "react";
import PropTypes from "prop-types";
import { getClassNameFactory } from "../../../../utilities";

var MobileHeaderRow = function MobileHeaderRow(_ref) {
  var headerLabel = _ref.headerLabel,
      labelP1 = _ref.labelP1,
      labelP2 = _ref.labelP2;
  var getClassName = getClassNameFactory(MobileHeaderRow.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, headerLabel), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "column-container"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "column"
    })
  }, labelP1), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "column"
    })
  }, labelP2)));
};

MobileHeaderRow.displayName = "PlanComparisonTable.MobileHeaderRow";
MobileHeaderRow.propTypes = {
  headerLabel: PropTypes.string,
  labelP1: PropTypes.string,
  labelP2: PropTypes.string
};
export default MobileHeaderRow;